import React, { useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import ScrollToTop from './helper/ScrollToTop';
import { GlobalStyle } from "./components/common/styles/global.js";
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';
import styled from "styled-components";
import { GlobalContext } from './pages/courses/contentdelivery/contexts/GlobalContext';
import UserService from './services/UserService';
import axios from 'axios';
import "../src/assets/css/all.css";
import "../src/assets/css/line-awesome.min.css";
import "../src/assets/css/swiper.min.css";
import "../src/assets/css/font-awesome.min.css";
import { Routes } from './Routes.jsx';
import cookies from "js-cookie"
import { BrowserRouter } from 'react-router-dom/cjs/react-router-dom.min.js';

const Container = styled.div`
  margin: 5px auto 5px auto;
`;

function App({ store, history }) {

    const [globalContextState, setGlobalContextState] = useState({
        currentId: "",
        currentPath: "",
        selectedIndex: 1,
        currentNodeType: '',
        apiData: [],
        discussionData: [],
        queryData: [],
        activityProgress: " ",
        DependencyActivityProgress: " ",
        // arcane: "meghsikshak",
        arcane: "cakes",
        _courseName: "",
        courseOwner: false,
        courseOwnerId: "IIIDDDDD",
        globalSpinner: false

    });

    ////CODE TO REFRESH THE TOKEN
    axios.interceptors.request.use(async (config) => {
        if (UserService.getToken() !== undefined) {
            try {
                UserService.getAttribute().then((resp) => {
                })
                await UserService.updateToken(60);
                if (cookies.get("token") && cookies.get("refreshtoken")) {
                    cookies.set("token", UserService.getToken())
                    cookies.set("refreshtoken", UserService.getRefreshToken())
                }
                config.headers['Authorization'] = `Bearer ${UserService.getToken()}`;
            } catch (error) {
                cookies.remove("refreshtoken")
                cookies.remove("token")
                await UserService.doLogout()
            }
        }
        return config;
    });



    return (
        <Provider store={store}>
            <GlobalContext.Provider value={{ globalContextState, setGlobalContextState }}>
                {/* <BrowserRouter basename='chariot'> */}
                    <Router history={history}>
                        <GlobalStyle />
                        <ScrollToTop />
                        <Routes />
                    </Router>
                {/* </BrowserRouter> */}
            </GlobalContext.Provider>
        </Provider >
    )
}

App.propTypes = {
    history: PropTypes.any.isRequired,
    store: PropTypes.any.isRequired
};

export default App;